import { Component, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-error-validacion-borrado',
  templateUrl: './error-validacion-borrado.component.html',
  standalone: false,
  styleUrls: ['./error-validacion-borrado.component.css']
})
export class ErrorValidacionBorradoComponent  implements OnInit {
  modalRef = inject(DynamicDialogRef);
  modalConfig = inject(DynamicDialogConfig);

  public mensaje: string = '';
  public validaciones: Array<any> | undefined;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  ngOnInit(): void {
    this.mensaje = this.modalConfig.data.mensaje;
    this.validaciones = this.modalConfig.data.validaciones;
  }

  public cerrar() {
    this.modalRef.close();
  }
}
